/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.7.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var Application =
/** @class */
function () {
  function Application() {}

  return Application;
}();

export { Application };